/** AI search includes today; website providers report completed days through yesterday. */
export function buildDataOverviewRanges(days: number, now = new Date()) {
  const today = new Date(now);
  today.setUTCHours(0, 0, 0, 0);
  const dateOffset = (offset: number) => {
    const date = new Date(today);
    date.setUTCDate(date.getUTCDate() + offset);
    return date.toISOString().slice(0, 10);
  };

  return {
    intelligence: {
      startDate: dateOffset(1 - days),
      endDate: dateOffset(0),
      // pipeline-ui uses an exclusive end bound, unlike website performance.
      endDateExclusive: dateOffset(1),
    },
    website: {
      startDate: dateOffset(-days),
      endDate: dateOffset(-1),
    },
  };
}
